import { buildService } from '@rd-web-markets/shared/dist/services/service';
import serviceMethods from '@rd-web-markets/shared/dist/services/service_methods';
import { useCallback } from 'react';
const contractsApi = buildService('/claim_project_reports/{id}/customer_contracts', {
  only: ['all', 'create', 'update', 'delete']
});
const customerContractsService = {
  useFetchAll: (setLoading, reportId) => {
    const [contracts, setContracts, fetchContracts] = serviceMethods.useFetch({
      callback: useCallback(async () => {
        if (!reportId) return [];
        const response = await contractsApi.all(reportId);
        return Array.isArray(response) ? response : [];
      }, [reportId]),
      setLoading,
      initialStateValue: []
    });
    return [contracts, setContracts, fetchContracts];
  },
  useCreate: (setLoading, setContracts, contracts, reportId) => {
    const createContract = serviceMethods.useCreate({
      callback: useCallback(async data => {
        if (!reportId) return;
        const response = await contractsApi.create(reportId, {
          customer_contract: data
        });
        setContracts([response, ...contracts]);
        return response;
      }, [contracts, setContracts, reportId]),
      setLoading
    });
    return [createContract];
  },
  useUpdate: (setLoading, setContracts, contracts, reportId) => {
    const updateContract = serviceMethods.useUpdate({
      callback: useCallback(async _ref => {
        let {
          id,
          data
        } = _ref;
        if (!reportId) return;
        const response = await contractsApi.update(reportId, id, {
          customer_contract: data
        });
        setContracts(contracts.map(c => c.id === id ? response : c));
        return response;
      }, [contracts, setContracts, reportId]),
      setLoading
    });
    return [updateContract];
  },
  useDelete: (setLoading, setContracts, contracts, reportId) => {
    const deleteContract = serviceMethods.useDelete({
      callback: useCallback(async contractId => {
        if (!reportId) return;
        await contractsApi.delete(reportId, contractId);
        setContracts(contracts.filter(c => c.id !== Number(contractId)));
      }, [contracts, setContracts, reportId]),
      setLoading
    });
    return [deleteContract];
  }
};
customerContractsService.useCrud = (setLoading, reportId) => {
  const [contracts, setContracts, fetchContracts] = customerContractsService.useFetchAll(setLoading, reportId);
  const [createContract] = customerContractsService.useCreate(setLoading, setContracts, contracts, reportId);
  const [updateContract] = customerContractsService.useUpdate(setLoading, setContracts, contracts, reportId);
  const [deleteContract] = customerContractsService.useDelete(setLoading, setContracts, contracts, reportId);
  return {
    contracts,
    setContracts,
    fetchContracts,
    createContract,
    updateContract,
    deleteContract
  };
};
export default customerContractsService;